export function SkeletonLines({ lines = 3, className = '' }: { lines?: number; className?: string }) {
  return (
    <div className={`space-y-2.5 ${className}`} aria-hidden="true">
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className="skeleton h-4 rounded-full" style={{ width: `${90 - ((i * 17) % 40)}%` }} />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 5 }: { rows?: number }) {
  return (
    <div className="dr-surface space-y-3 p-4 sm:p-5" aria-hidden="true">
      <div className="skeleton h-5 w-1/3 rounded-full" />
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="skeleton h-9 w-full rounded-field" style={{ opacity: 1 - i * 0.12 }} />
      ))}
    </div>
  );
}

export function PageSkeleton() {
  return (
    <div className="animate-fade space-y-6" role="status" aria-label="Loading">
      <div className="space-y-2.5">
        <div className="skeleton h-4 w-40 rounded-full" />
        <div className="skeleton h-9 w-72 max-w-full rounded-full" />
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="skeleton h-28 rounded-box" />
        <div className="skeleton h-28 rounded-box" />
        <div className="skeleton h-28 rounded-box" />
      </div>
      <SkeletonTable />
    </div>
  );
}
